import { FC } from "react";
import { BuscarComponent } from "../../../../shared/providers/ListView/BuscarComponent";
import { ListaBotonesComponent } from "./AuditoriaUsuarioHeaderToolbar";

export const AuditoriaUsuarioHeaderToolbar: FC = () => {
    
    return (
        <div className='card-header border-0 py-4'>
            <BuscarComponent placeholder="Buscar" />
            <div className='card-toolbar'>
                <ListaBotonesComponent />
            </div>
        </div>
    )
}